import {
  Check,
  ChevronDown,
  DollarSign,
  Download,
  MoreVertical,
  Search,
  IndianRupee,
  Star,
  BadgeCheck,
  X,
} from "lucide-react";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TopNavbar from "../../components/AdminPortal/TopNavbar";
import { useSidebar } from "../../context/SidebarContext";
import { affiliateAPI } from "../../services/AdminPortal/affiliateAPI";
import * as XLSX from "xlsx";
import JSZip from "jszip";
import { toast } from "react-hot-toast";
import { notificationAPI } from "../../services/notificationAPI";
import { useAuth } from "../../context/AuthContext";
import AffiliateInformation from "../../components/AffiliatePartner/AffiliateInformation";
import ApplicationsList from "../../components/AdminPortal/ApplicationsList";
import CustomerList from "../../components/AdminPortal/CustomerList";
import BankAccountDetails from "../../components/AdminPortal/BankAccountDetails";

export default function AffiliateProfilePage() {
  const { sidebarExpanded, isMobile } = useSidebar();
  const navigate = useNavigate();

  const { user } = useAuth();
  const currentUserId = user?.id;
  const adminId = user?.id;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [profile, setProfile] = useState(null);
  const [applications, setApplications] = useState([]);
  const [selectedApplications, setSelectedApplications] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showFilterPopup, setShowFilterPopup] = useState(false);
  const [filters, setFilters] = useState({
    status: "all",
    dateRange: "all",
    loanType: "all",
  });
  const [filteredApplications, setFilteredApplications] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [activeTab, setActiveTab] = useState("payments");

  // Customer-specific state
  const [customers, setCustomers] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [customerSelectAll, setCustomerSelectAll] = useState(false);
  const [showCustomerFilterPopup, setShowCustomerFilterPopup] = useState(false);
  const [customerFilters, setCustomerFilters] = useState({
    status: "all",
    customerType: "all",
    dateRange: "all",
    city: "all",
  });
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [customerSearchQuery, setCustomerSearchQuery] = useState("");

  // Fetch customers from backend
  const fetchCustomers = async (partnerId) => {
    try {
      setLoading(true);
      setError(null);
      const response = await affiliateAPI.getAffiliateCustomers(partnerId);
      if (response.success && response.data) {
        setCustomers(response.data);
      } else {
        throw new Error(response.message || "Invalid customer data structure");
      }
    } catch (err) {
      console.error("Error in fetchCustomers:", err);
      setError(
        err.message || "Failed to fetch customers. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  const sendNotification = async (
    userId,
    note,
    notificationType,
    senderUserId
  ) => {
    try {
      const notification = await notificationAPI.sendNotification(
        userId,
        note,
        notificationType,
        senderUserId
      );
      toast.success(`Notification sent: ${note}`);
      console.log("Notification sent:", notification);
    } catch (error) {
      console.error("Error sending notification:", error);
      toast.error("Could not send notification.");
    }
  };
  useEffect(() => {
    fetchData();
  }, [currentUserId]);

  useEffect(() => {
    let filtered = applications;

    // Apply status filter
    if (filters.status !== "all") {
      filtered = filtered.filter((app) => app.status === filters.status);
    }

    // Apply date range filter
    if (filters.dateRange !== "all") {
      const today = new Date();
      const thirtyDaysAgo = new Date(today);
      thirtyDaysAgo.setDate(today.getDate() - 30);

      filtered = filtered.filter((app) => {
        const applicationDate = new Date(app.createdAt);
        if (filters.dateRange === "last30days") {
          return applicationDate >= thirtyDaysAgo;
        }
        return true;
      });
    }

    // Apply loan type filter
    if (filters.loanType !== "all") {
      filtered = filtered.filter((app) => app.loanType === filters.loanType);
    }

    setFilteredApplications(filtered);
  }, [applications, filters]);
  console.log(filteredApplications, "kkkkkkkkkkkkkkkkkkkkkllll");
  console.log(profile, "lllllllllllllllllllllllllllll");

  // Customer filtering useEffect
  useEffect(() => {
    let filtered = customers;

    // Apply search filter
    if (customerSearchQuery.trim() !== "") {
      filtered = filtered.filter(
        (customer) =>
          customer.name
            ?.toLowerCase()
            .includes(customerSearchQuery.toLowerCase()) ||
          customer.email
            ?.toLowerCase()
            .includes(customerSearchQuery.toLowerCase()) ||
          customer.contact
            ?.toLowerCase()
            .includes(customerSearchQuery.toLowerCase())
      );
    }

    // Apply status filter
    if (customerFilters.status !== "all") {
      filtered = filtered.filter(
        (customer) => customer.status === customerFilters.status
      );
    }

    // Apply customer type filter
    if (customerFilters.customerType !== "all") {
      filtered = filtered.filter(
        (customer) => customer.customerType === customerFilters.customerType
      );
    }

    // Apply date range filter
    if (customerFilters.dateRange !== "all") {
      const today = new Date();
      const thirtyDaysAgo = new Date(today);
      thirtyDaysAgo.setDate(today.getDate() - 30);
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() - 7);
      const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);

      filtered = filtered.filter((customer) => {
        const joiningDate = new Date(customer.joiningDate);
        if (customerFilters.dateRange === "last30days") {
          return joiningDate >= thirtyDaysAgo;
        } else if (customerFilters.dateRange === "last7days") {
          return joiningDate >= sevenDaysAgo;
        } else if (customerFilters.dateRange === "thisMonth") {
          return joiningDate >= thisMonthStart;
        }
        return true;
      });
    }

    // Apply city filter
    if (customerFilters.city !== "all") {
      filtered = filtered.filter(
        (customer) => customer.city === customerFilters.city
      );
    }

    setFilteredCustomers(filtered);
  }, [customers, customerFilters, customerSearchQuery]);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      // Fetch profile data using current user's profile
      const profileData = await affiliateAPI.getCurrentUserProfile();
      const partnerId =
        profileData.data.affiliatePartner?._id ||
        profileData.data.affiliatePartner?.id;
      console.log("Resolved partnerId:", partnerId); // Debug log
      if (!partnerId) throw new Error("Partner ID not found in profile data");
      // Set profile data from affiliatePartner
      if (profileData.success && profileData.data) {
        console.log("Setting profile to:", profileData.data.affiliatePartner); // Debug log
        setProfile(profileData.data.affiliatePartner);
      } else {
        throw new Error("Invalid profile data structure");
      }
      // Fetch applications data using the partner ID from profile
      try {
        const applicationsData = await affiliateAPI.getAffiliateApplications(
          partnerId
        );
        if (applicationsData.success && applicationsData.data) {
          setApplications(applicationsData.data);
        } else {
          throw new Error("Invalid applications data structure");
        }
      } catch (err) {
        setError("Failed to fetch applications. Please try again later.");
      }
      // Fetch customers from backend
      await fetchCustomers(partnerId);
    } catch (err) {
      setError(err.message || "Failed to fetch data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // Debug: log profile before rendering
  console.log("Profile state before render:", profile);

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedApplications([]);
    } else {
      setSelectedApplications(applications.map((app) => app._id));
    }
    setSelectAll(!selectAll);
  };

  const handleSelectApplication = (id) => {
    if (selectedApplications.includes(id)) {
      setSelectedApplications(
        selectedApplications.filter((appId) => appId !== id)
      );
    } else {
      setSelectedApplications([...selectedApplications, id]);
    }
  };

  // Customer-specific functions
  const handleCustomerSelectAll = () => {
    if (customerSelectAll) {
      setSelectedCustomers([]);
    } else {
      setSelectedCustomers(customers.map((customer) => customer._id));
    }
    setCustomerSelectAll(!customerSelectAll);
  };

  const handleSelectCustomer = (id) => {
    if (selectedCustomers.includes(id)) {
      setSelectedCustomers(
        selectedCustomers.filter((customerId) => customerId !== id)
      );
    } else {
      setSelectedCustomers([...selectedCustomers, id]);
    }
  };

  const handleCustomerFilterChange = (filterType, value) => {
    setCustomerFilters((prev) => ({
      ...prev,
      [filterType]: value,
    }));
  };

  const resetCustomerFilters = () => {
    setCustomerFilters({
      status: "all",
      customerType: "all",
      dateRange: "all",
      city: "all",
    });
  };

  const handleCustomerSearch = (e) => {
    setCustomerSearchQuery(e.target.value);
  };

  const handleStatusUpdate = async (newStatus) => {
    try {
      const partnerId = profile?._id;
      if (!partnerId) {
        throw new Error("Partner ID not available");
      }
      await affiliateAPI.updateAffiliateStatus(partnerId, newStatus);
      await fetchData(); // Refresh data after status update
    } catch (err) {
      console.error("Error updating status:", err);
      setError("Failed to update status. Please try again.");
    }
  };

  const handleDownloadDocument = async (documentType) => {
    console.log("button is clicking !!");
    try {
      const partnerId = profile?._id;
      if (!partnerId) {
        throw new Error("Partner ID not available");
      }
      const blob = await affiliateAPI.downloadAffiliateDocument(
        partnerId,
        documentType
      );
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${documentType}_${profile.name}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (err) {
      console.error("Error downloading document:", err);
      setError("Failed to download document. Please try again.");
    }
  };

  const formatCurrency = (value) => {
    if (value === undefined || value === null) return "₹0";
    // Remove existing currency symbols for parsing, then reformat
    const numValue = Number(String(value).replace(/[^0-9.-]+/g, ""));
    return `₹${numValue.toLocaleString("en-IN")}`;
  };

  const handleExportProfileAndApplicationsData = async () => {
    console.log("handleExportProfileAndApplicationsData called");
    console.log("Current profile state:", profile);

    if (!profile) {
      // Check if profile data itself is available
      toast.error("Profile data is not available to export.");
      console.error("Export aborted: Profile data is null or undefined.");
      return;
    }

    try {
      setLoading(true);
      toast.loading("Preparing export data...");
      console.log("Export process started, loading set to true.");

      const partner = profile; // Use profile directly as it holds the partner details

      // --- Prepare Data for Sheet 1: Partner Profile ---
      const profileDetailsData = [
        { Field: "Partner ID", Value: partner.id || partner._id },
        { Field: "Name", Value: partner.name },
        { Field: "Email", Value: partner.email },
        { Field: "Contact Number", Value: partner.contact },
        { Field: "Joining Date", Value: partner.joiningDate },
        { Field: "Affiliate Category", Value: partner.category },
        { Field: "Status", Value: partner.status },
        { Field: "Star Partner", Value: partner.isStarPartner ? "Yes" : "No" }, // Ensure profile has isStarPartner
        {
          Field: "Commission Rate",
          Value: `${partner.commissionDetails?.rate || 0}%`,
        },
      ];
      // Calculate commission details safely
      const totalCommission = Number(
        String(partner.performance?.totalCommission || "0").replace(
          /[^0-9.-]+/g,
          ""
        )
      );
      const pendingCommission = Number(
        String(partner.performance?.pendingCommission || "0").replace(
          /[^0-9.-]+/g,
          ""
        )
      );
      const calculatedPaidCommission = totalCommission - pendingCommission;

      profileDetailsData.push({
        Field: "Total Commission",
        Value: formatCurrency(totalCommission),
      });
      profileDetailsData.push({
        Field: "Paid Commission",
        Value: formatCurrency(calculatedPaidCommission),
      });
      profileDetailsData.push({
        Field: "Pending Commission",
        Value: formatCurrency(pendingCommission),
      });

      // --- Prepare Data for Sheet 2: Applications ---
      const applicationsDataForSheet = filteredApplications.map((app) => ({
        "Application ID": app._id,
        "Applicant Name": app.applicantName,
        "Loan Amount": formatCurrency(app.loanAmount),
        "Loan Type": app.loanType,
        Status: app.status,
        "Date Submitted": new Date(app.createdAt).toLocaleDateString(),
        "Assigned To": app.assignedTo?.name || "Unassigned",
        "Processing Type": app.processingType || "Standard",
      }));

      console.log(
        "Profile details for Excel:",
        JSON.stringify(profileDetailsData, null, 2)
      );
      console.log(
        "Applications data for Excel:",
        JSON.stringify(applicationsDataForSheet, null, 2)
      );

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(profileDetailsData),
        "Partner Profile"
      );

      if (applicationsDataForSheet.length > 0) {
        XLSX.utils.book_append_sheet(
          wb,
          XLSX.utils.json_to_sheet(applicationsDataForSheet),
          "Applications"
        );
      } else {
        XLSX.utils.book_append_sheet(
          wb,
          XLSX.utils.json_to_sheet([
            { Message: "No applications found for this partner." },
          ]),
          "Applications"
        );
      }
      console.log("Excel workbook created.");

      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      console.log("Excel buffer generated, length:", excelBuffer?.byteLength);

      if (!excelBuffer || excelBuffer.byteLength === 0) {
        console.error("Excel buffer is empty or invalid.");
        toast.error("Failed to generate Excel data.");
        setLoading(false);
        toast.dismiss();
        return;
      }

      // Create a zip file
      const zip = new JSZip();
      zip.file(`${partner.name}_Profile_and_Applications.xlsx`, excelBuffer);
      console.log("Excel file added to zip.");

      const zipBlob = await zip.generateAsync({ type: "blob" });
      console.log("Zip blob generated:", zipBlob);

      const url = window.URL.createObjectURL(zipBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${partner.name}_Profile_and_Applications.zip`; // Download as .zip
      document.body.appendChild(a);
      console.log("Download link created, attempting click:", a);
      a.click();
      console.log("Download click triggered.");
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      toast.dismiss();
      toast.success("Partner data exported successfully!");
    } catch (err) {
      console.error("Error exporting profile data:", err);
      toast.dismiss();
      toast.error(
        `Failed to export profile data: ${err.message}. Check console.`
      );
    } finally {
      setLoading(false);
    }
  };

  const navigateToApplication = (appId) => {
    navigate(`/admin/loan-applications/approval/${appId}`);
  };

  const handleFilterChange = (filterType, value) => {
    setFilters((prev) => ({
      ...prev,
      [filterType]: value,
    }));
  };

  const resetFilters = () => {
    setFilters({
      status: "all",
      dateRange: "all",
      loanType: "all",
    });
  };

  const openDocumentModal = (document) => {
    console.log("Opening modal with document:", document);
    setSelectedDocument(document);
    setShowDocumentModal(true);
  };

  const closeModal = () => {
    setSelectedDocument(null);
    setShowDocumentModal(false);
  };

  const handleVerifyDocument = async (documentType, status) => {
    console.log("Updating document:", documentType, "with status:", status);
    try {
      const partnerId = profile?._id;
      if (!partnerId) {
        throw new Error("Partner ID not available");
      }
      const updatedDoc = await affiliateAPI.verifyDocument(
        partnerId,
        documentType,
        status
      );
      console.log("Document status updated:", updatedDoc);

      // Update local state immediately
      setProfile((prevProfile) => ({
        ...prevProfile,
        documents: prevProfile.documents.map((document) =>
          document.type === documentType ? { ...document, status } : document
        ),
      }));

      toast.success("Document status updated successfully");
    } catch (error) {
      console.error("Error updating document status:", error);
      toast.error("Failed to update document status");
    }
    closeModal();
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#131313] text-white flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-yellow-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-[#131313] text-white flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-500 mb-4">{error}</p>
          <button
            onClick={fetchData}
            className="bg-[#FFCA20] text-black px-4 py-2 rounded-md"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="min-h-screen bg-[#131313] text-white flex items-center justify-center">
        <p className="text-gray-400">Profile not found</p>
      </div>
    );
  }

  // Calculate paidCommission for display in JSX
  let paidCommissionForDisplay = 0;
  if (profile && profile.performance) {
    const totalCommission = Number(
      String(profile.performance.totalCommission || "0").replace(
        /[^0-9.-]+/g,
        ""
      )
    );
    const pendingCommission = Number(
      String(profile.performance.pendingCommission || "0").replace(
        /[^0-9.-]+/g,
        ""
      )
    );
    paidCommissionForDisplay = totalCommission - pendingCommission;
  }
  return (
    <div
      className="min-h-screen bg-[#000000] text-white mt-12"
      style={{
        marginLeft: isMobile ? "0" : sidebarExpanded ? "200px" : "60px",
        width: isMobile
          ? "100%"
          : `calc(100% - ${sidebarExpanded ? "200px" : "60px"})`,
      }}
    >
      <TopNavbar />

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Header */}

        {/* Profile Content */}
        <div className="p-4 sm:p-6 flex-1 overflow-auto">
          {/* Profile Header */}
          <div className="bg-[#131313] border border-[#333333] p-4 sm:p-6 rounded-lg mb-6">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 w-full md:w-auto">
                <div className="flex justify-between items-start w-full sm:w-auto">
                  {/*profile image section */}
                  <div className="relative">
                    <div className="w-16 h-16 rounded-full bg-purple-500 flex items-center justify-center overflow-hidden">
                      <img
                        src={
                          profile.profileImage ||
                          "https://www.w3schools.com/howto/img_avatar.png"
                        }
                        alt={profile.name}
                      />
                    </div>
                  </div>
                  {/*button section - shows on mobile to the right of profile image */}
                  <div className="flex gap-2 sm:hidden">
                    <button
                      className="bg-[#FFCA20] text-black px-3 py-2 rounded-md flex items-center mr-2 text-sm"
                      onClick={handleExportProfileAndApplicationsData}
                    >
                      <Download className="w-4 h-4 mr-1" />
                      Export Data
                    </button>
                  </div>
                </div>
                <div className="ml-0 sm:ml-4">
                  <div className="flex items-center">
                    <h2 className="text-2xl font-bold">{profile.name}</h2>
                    {profile.isStarPartner && (
                      <Star className="ml-2 text-[#FFCA20] w-5 h-5" />
                    )}
                    {/* <span className="ml-2 text-green-400 text-sm">
                      {profile.performance?.successRate || 0}% Success Rate
                    </span> */}
                  </div>
                  <div className="flex flex-col sm:flex-row sm:items-center text-gray-400 text-sm sm:text-base mt-1 sm:mt-0">
                    <span className="mr-1">PARTNER ID</span>
                    <span>{profile.id}</span>
                  </div>
                </div>
              </div>
              {/*button section - shows on desktop */}
              <div className="hidden sm:flex gap-2 justify-end">
                <button
                  className="bg-[#FFCA20] text-black px-3 sm:px-4 py-2 rounded-md flex items-center mr-2 text-sm sm:text-base"
                  onClick={handleExportProfileAndApplicationsData}
                >
                  <Download className="w-4 h-4 sm:w-5 sm:h-5 mr-1 sm:mr-2" />
                  Export Data
                </button>
              </div>
            </div>

            <div className="flex flex-wrap gap-4 sm:gap-8 mt-4">
              {/* Each block follows same pattern */}
              <div className="sm:border-r border-[#333333] sm:pr-4 w-full sm:w-auto">
                <p className="text-[#F3F3F3] text-[12px]">Contact Number</p>
                <p className="text-[#F3F3F3] text-[16px]">{profile.contact}</p>
              </div>

              <div className="sm:border-r border-[#333333] sm:pr-4 w-full sm:w-auto">
                <p className="text-[#F3F3F3] text-[12px]">Email ID</p>
                <p className="text-[#F3F3F3] text-[16px]">{profile.email}</p>
              </div>

              <div className="sm:border-r border-[#333333] sm:pr-4 w-full sm:w-auto">
                <p className="text-[#F3F3F3] text-[12px]">Date of Joining</p>
                <p className="text-[#F3F3F3] text-[16px]">
                  {new Date(profile.joiningDate).toLocaleDateString()}
                </p>
              </div>

              <div className="sm:border-r border-[#333333] sm:pr-4 w-full sm:w-auto">
                <p className="text-[#F3F3F3] text-[12px]">Affiliate Category</p>
                <p className="text-[#F3F3F3] text-[16px]">{profile.category}</p>
              </div>

              <div className="sm:border-r border-[#333333] sm:pr-4 w-full sm:w-auto">
                <p className="text-[#F3F3F3] text-[12px]">Location</p>
                <p className="text-[#F3F3F3] text-[16px]">{profile.location}</p>
              </div>

              <div className="sm:border-r border-[#333333] sm:pr-4 w-full sm:w-auto">
                <p className="text-[#F3F3F3] text-[12px]">PIN</p>
                <p className="text-[#F3F3F3] text-[16px]">{profile.pinCode}</p>
              </div>

              <div className="w-full sm:w-auto">
                <p className="text-[#F3F3F3] text-[12px]">Age</p>
                <p className="text-[#F3F3F3] text-[16px]">{profile.age}</p>
              </div>
            </div>
            {/* ✅ Branch Details */}
            <div className="w-full mt-4">
              <h3 className="text-sm font-semibold text-[#FFCA20] mb-2">
                Branch Details
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <div className="text-xs text-gray-400">Branch Name</div>
                  <div>{profile.branchName}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-400">Branch Type</div>
                  <div>
                    {profile.branchType === "district"
                      ? "District Level"
                      : profile.branchType === "mandal"
                      ? "Mandal Level"
                      : profile.branchType === "village"
                      ? "Village Level"
                      : profile.branchType}
                  </div>
                </div>
                <div>
                  <div className="text-xs text-gray-400">Branch Location</div>
                  <div>{profile.branchLocation}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Tab Content */}
          <div className="border-b border-[#333333] mb-4 overflow-x-auto scrollbar-hide">
            <div className="flex flex-nowrap gap-4 sm:gap-8">
              <button
                className={`tab-button ${
                  activeTab === "payments"
                    ? "active-tab-border"
                    : "inactive-tab"
                }`}
                onClick={() => setActiveTab("payments")}
              >
                Payments
              </button>
              <button
                className={`tab-button ${
                  activeTab === "bank" ? "active-tab-border" : "inactive-tab"
                }`}
                onClick={() => setActiveTab("bank")}
              >
                Bank Account Details
              </button>
              <button
                className={`tab-button ${
                  activeTab === "documents"
                    ? "active-tab-border"
                    : "inactive-tab"
                }`}
                onClick={() => setActiveTab("documents")}
              >
                Documents
              </button>
            </div>
          </div>

          {activeTab === "payments" && (
            <AffiliateInformation
              profile={profile}
              formatCurrency={formatCurrency}
              paidCommissionForDisplay={paidCommissionForDisplay}
              openDocumentModal={openDocumentModal}
            />
          )}
          {activeTab === "bank" && (
            <BankAccountDetails
              bankDetails={profile.accountDetails}
              partnerId={profile._id}
              onEdit={() => {}}
              onSave={(updated) => {
                setProfile((prev) => ({ ...prev, accountDetails: updated }));
              }}
            />
          )}
          {activeTab === "documents" && (
            <div className="bg-[#131313] border border-[#333333] p-4 sm:p-6 rounded-lg">
              <h3 className="text-lg font-bold mb-4 flex items-center">
                <BadgeCheck className="text-[#FFCA20] mr-2" /> Compliance Status
              </h3>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {profile.documents &&
                  Array.isArray(profile.documents) &&
                  profile.documents.map((doc) => {
                    const documentType = doc.type
                      ? doc.type.replace(/_/g, " ")
                      : "Document";
                    return (
                      <div
                        key={doc.type}
                        className="border border-[#333333] rounded-lg p-4"
                      >
                        <div className="flex flex-col sm:flex-row justify-between mb-1">
                          <p className="capitalize">{documentType}</p>
                          <div
                            className={`${
                              doc.status?.toLowerCase() === "verified"
                                ? "bg-green-500"
                                : doc.status?.toLowerCase() === "rejected"
                                ? "bg-red-500"
                                : "bg-[#FFCA20]"
                            } bg-opacity-20 ${
                              doc.status?.toLowerCase() === "verified"
                                ? "text-green-500"
                                : doc.status?.toLowerCase() === "rejected"
                                ? "text-red-500"
                                : "text-[#FFCA20]"
                            } px-3 py-1 rounded-full flex items-center mt-2 sm:mt-0`}
                          >
                            <Check className="w-4 h-4 mr-1" />{" "}
                            {doc.status?.toLowerCase() === "verified"
                              ? "Verified"
                              : doc.status?.toLowerCase() === "rejected"
                              ? "Rejected"
                              : "Pending"}
                          </div>
                        </div>
                        <div className="flex justify-between gap-2 mt-2">
                          <div className="flex flex-row gap-2">
                            <p className="text-gray-400 text-xs">
                              Submitted on
                            </p>
                            <p className="text-gray-400 text-xs">
                              {doc.uploadedAt
                                ? new Date(doc.uploadedAt).toLocaleDateString()
                                : "Not submitted"}
                            </p>
                          </div>
                          <div>
                            <div className="flex gap-2">
                              {doc.filePath && (
                                <>
                                  <button
                                    className="text-[#FFCA20] text-sm"
                                    onClick={() => openDocumentModal(doc)}
                                  >
                                    View
                                  </button>
                                  <button
                                    className="text-[#FFCA20] text-sm"
                                    onClick={async () => {
                                      try {
                                        const response = await fetch(
                                          doc.filePath
                                        );
                                        const blob = await response.blob();
                                        const url =
                                          window.URL.createObjectURL(blob);
                                        const link =
                                          document.createElement("a");
                                        link.href = url;
                                        link.download =
                                          doc.fileName ||
                                          `document_${doc.type || "file"}`;
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);
                                        window.URL.revokeObjectURL(url);
                                      } catch (error) {
                                        // fallback
                                        const link =
                                          document.createElement("a");
                                        link.href = doc.filePath;
                                        link.download =
                                          doc.fileName ||
                                          `document_${doc.type || "file"}`;
                                        link.click();
                                      }
                                    }}
                                  >
                                    Download
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Document Modal */}
      {showDocumentModal && selectedDocument && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-2 sm:p-4">
          <div className="bg-[#131313] p-3 sm:p-4 rounded-lg max-w-4xl w-full">
            <div className="flex justify-between items-center mb-2 sm:mb-4">
              <h3 className="text-base sm:text-lg font-semibold">
                Document Preview
              </h3>
              <button
                onClick={closeModal}
                className="text-gray-400 hover:text-white p-1"
              >
                ✕
              </button>
            </div>
            <div className="relative w-full h-[50vh] sm:h-[70vh]">
              <img
                src={selectedDocument.filePath}
                alt={selectedDocument.fileName}
                className="w-full h-full object-contain"
              />
            </div>
            {/* Verification Actions */}
            {!["verified", "rejected"].includes(
              selectedDocument.status?.toLowerCase()
            ) && (
              <div className="p-2 sm:p-4 flex flex-wrap sm:flex-nowrap justify-end gap-2 sm:space-x-4">
                <button
                  onClick={async () => {
                    console.log("Selected document:", selectedDocument);
                    if (!selectedDocument.type) {
                      console.error("Document type is missing");
                      toast.error("Document type is missing");
                      return;
                    }

                    try {
                      await sendNotification(
                        profile._id,
                        "Please reupload your document",
                        "Admin",
                        adminId
                      );
                    } catch (error) {
                      console.error("Failed to send notification:", error);
                    }

                    await handleVerifyDocument(
                      selectedDocument.type,
                      "rejected"
                    );
                  }}
                  className="bg-red-500/20 border-red-500 border-2 hover:bg-red-800 px-3 sm:px-4 text-red-500 text-sm sm:text-base font-medium p-2 rounded flex items-center w-full sm:w-auto justify-center sm:justify-start"
                >
                  Reject <X className="w-4 h-4 ml-2" />
                </button>
                <button
                  onClick={async () => {
                    console.log("Selected document:", selectedDocument);
                    if (!selectedDocument.type) {
                      console.error("Document type is missing");
                      toast.error("Document type is missing");
                      return;
                    }
                    await handleVerifyDocument(
                      selectedDocument.type,
                      "verified"
                    );
                  }}
                  className="bg-green-300/20 border-green-500 border-2 hover:bg-green-800 px-3 sm:px-4 text-green-500 text-sm sm:text-base font-medium p-2 rounded flex items-center w-full sm:w-auto justify-center sm:justify-start"
                >
                  Verify <Check className="w-4 h-4 ml-2" />
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
